import uamClient from '../uam/uamClient';
import uamClientService from '../uam/uamClientService';
import uamfClient from '../uamf/uamfClient';
import uamfClientService from '../uamf/uamfClientService';
import damDeviceHelpers from './damDeviceHelpers';

const getClient = (dusn) => (damDeviceHelpers.isUamf(dusn) ? uamfClient : uamClient);

const getClientService = (dusn) => (damDeviceHelpers.isUamf(dusn) ? uamfClientService : uamClientService);

const getSubscription = (serialNumber) => getClientService(serialNumber).getSubscription(serialNumber);

const getDeviceConnectionStatus = (serialNumber, isThrowError) =>
    getClientService(serialNumber).getDeviceConnectionStatus(serialNumber, isThrowError);

const getDeviceInfo = (serialNumber, isThrowError, isCached) =>
    getClientService(serialNumber).getDeviceInfo(serialNumber, isThrowError, isCached);

const postDeviceSynchronize = (serialNumber) => getClientService(serialNumber).postDeviceSynchronize(serialNumber);

const postAuthToken = (serialNumber, assetId, consents) =>
    getClientService(serialNumber).postAuthToken(serialNumber, assetId, consents);

const postUpdateSetting = (serialNumber, settingName, newValue) =>
    getClientService(serialNumber).postUpdateSetting(serialNumber, settingName, newValue);

const getRequestStatus = (serialNumber, requestId) =>
    getClientService(serialNumber).getRequestStatus(serialNumber, requestId);

const getFirmwareUpdateAvailability = (serialNumber, languageCode) =>
    getClientService(serialNumber).getFirmwareUpdateAvailability(serialNumber, languageCode);

const postUpdateFirmware = (serialNumber) => getClientService(serialNumber).postUpdateFirmware(serialNumber);

const postGenerateExperienceInference = (serialNumber) =>
    getClientService(serialNumber).postGenerateExperienceInference(serialNumber);

const getExperienceInference = (serialNumber) => getClientService(serialNumber).getExperienceInference(serialNumber);

export default {
    getClient,
    getClientService,
    getSubscription,
    getDeviceConnectionStatus,
    getDeviceInfo,
    postDeviceSynchronize,
    postAuthToken,
    postUpdateSetting,
    getRequestStatus,
    getFirmwareUpdateAvailability,
    postUpdateFirmware,
    postGenerateExperienceInference,
    getExperienceInference,
};
